
import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ProcessPaymentService } from '../metodos-pagos/components/mercado-pago/components/process-payment/service/process-payment.service';

@Component({
  selector: 'mercado-pago-text-detail-shop',
  imports: [ReactiveFormsModule],
  templateUrl: './text-detail-shop.component.html',
  styleUrl: './text-detail-shop.component.css'
})
export class TextDetailShopComponent {


  textControl = new FormControl('');

  constructor(private processPaymentService: ProcessPaymentService) {
    this.textControl.valueChanges.subscribe(value => {
      this.processPaymentService.textDetail = value!


    });
  }
}
